import { combineReducers } from 'redux-immutable';
import value from './Reducers/reducer';
import modal from './Modal/reducer';

export default combineReducers({
  value,
  modal,
});

// Selectors
export const getRouting = state =>
  state.get('routing');
